export const getIdFromPath = (path) => path.split('/').slice(-1)[0];